<template>
    <div class="video-quantity-confirm">
        <p
        class="current-video-quantity"
        v-html="$t('videoQuantityConfirm.currentQuantity', { quantity: currentQuantity })">
        </p>
        <p class="sub-title">
            {{ $t('videoQuantityConfirm.subTitle') }}
        </p>
        <p class="plan-video-quantity" v-html="$t('videoQuantityConfirm.planQuantity', {
            quantity: planQuantity,
            plan: planTitle
        })">
        </p>
    </div>
</template>

<script>
export default {

    props: {

        currentQuantity: {
            required: true,
            type: Number
        },
        planQuantity: {
            required: true,
            type: Number
        },
        planTitle: {
            required: true,
            type: String
        }

    },

    data () {

        return {
        };

    }

};
</script>

<style lang="less">
.video-quantity-confirm{
    border-radius: 0.08rem;
    background-color: #f7f8f9;
    border: 1px solid #eee;
    width: 6rem;
    box-sizing: border-box;
    padding: 0.4rem 0.5rem;
    text-align: left;
    margin-bottom: 0.6rem;
    @media @mobile{
        padding: 0.4rem;
    }
    .current-video-quantity{
        margin-bottom: 0.3rem;
        @media @mobile{
            margin-bottom: 0.4rem;
        }
    }
    .sub-title{
        font-weight: 500;
        margin-bottom: 0.15rem;
        font-size: 0.26rem;
        @media @mobile{
            margin-bottom: 0.2rem;
            font-size: 0.3rem;
        }
    }
    .current-video-quantity,
    .plan-video-quantity{
        font-size: 0.22rem;
        @media @mobile{
            font-size: 0.26rem;
        }
    }
}
.video-quantity-confirm-dialog p.dialog-title{
    max-width: 4rem;
    margin: 0 auto 0.4rem;
    @media @mobile{
        max-width: 100%;
    }
}
.video-quantity-confirm-dialog .reo-dialog-inner .ui-button{
    width: auto;
    margin-top: 0 !important;
}
.video-quantity-confirm-dialog .reo-dialog-inner .ui-button+.ui-button{
    margin-left: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/videoQuantityConfirm.vue